import { render } from "./tw-subject.vue?vue&type=template&id=5c9e2093"
import script from "./tw-subject.vue?vue&type=script&lang=js"
export * from "./tw-subject.vue?vue&type=script&lang=js"
script.render = render

export default script